import React, { useState, useRef } from "react";
import { Box, Paper, Typography } from "@mui/material";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";

const DragAndDropPicUpload = ({
  types = ["image/png"],
  sizeLimit = 5,
  data,
  setData,
}) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [invalidMessage, setInvalidMessage] = useState(null);
  const fileInputRef = useRef(null);

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleFileDrop = (files) => {
    const file = files[0];
    validateAndSetFile(file);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const file = files[0];
    validateAndSetFile(file);
  };

  const validateAndSetFile = (file) => {
    if (!file) return;

    const isValidFileType = types.includes(file.type);

    if (!isValidFileType) {
      setSelectedFile(null);
      setImagePreview(null);
      setInvalidMessage(
        "Invalid file type! Please select an appropriate file."
      );
    } else {
      setSelectedFile(file);
      setInvalidMessage(null);
      const imageURL = URL.createObjectURL(file);
      setImagePreview(imageURL);
      setData({ ...data, image_filename: file });
    }
  };

  const handleUploadAreaClick = () => {
    fileInputRef.current.click();
  };

  return (
    <Paper
      sx={{
        height: { md: "14rem", sm: "12rem", xs: "10rem" },
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid",
        borderColor: isDragOver ? "primary.main" : "text.secondary",
        borderRadius: "4px",
        padding: "1rem",
        textAlign: "center",
        cursor: "pointer",
      }}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.preventDefault();
        setIsDragOver(false);
        handleFileDrop(Array.from(e.dataTransfer.files));
      }}
      onClick={handleUploadAreaClick}
    >
      <input
        type="file"
        accept={types.join(",")}
        multiple={false}
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleFileChange}
        name="image_filename"
      />

      {invalidMessage ? (
        <Typography color="red">{invalidMessage}</Typography>
      ) : selectedFile ? (
        <img
          src={imagePreview}
          alt="Advertisement Pic"
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            display: "block",
          }}
        />
      ) : (
        <Box>
          <AddCircleRoundedIcon fontSize="large" color="primary" />
          <Typography sx={{ opacity: 0.5 }}>Advertisement Pic</Typography>
        </Box>
      )}
    </Paper>
  );
};

export default DragAndDropPicUpload;
